<template>
    <div class="loadings" v-loading="true"> 
        
    </div>
</template>
<script>
export default {
    data(){
        return{
            height:'120px'
        }
    }
}
</script>
<style lang="scss" scoped>
    .loadings{
        height: calc(100vh - 120px);
    }
</style>
